/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./payment-status.component";
import * as i2 from "@angular/router";
import * as i3 from "../../../shared/services/cache.service";
var styles_PaymentStatusComponent = [];
var RenderType_PaymentStatusComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_PaymentStatusComponent, data: {} });
export { RenderType_PaymentStatusComponent as RenderType_PaymentStatusComponent };
export function View_PaymentStatusComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "div", [["class", "col p-0 template3 border-outline"]], null, null, null, null, null)), (_l()(), i0.ɵted(-1, null, ["\n"])), (_l()(), i0.ɵted(-1, null, ["\n"]))], null, null); }
export function View_PaymentStatusComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-payment-status", [], null, null, null, View_PaymentStatusComponent_0, RenderType_PaymentStatusComponent)), i0.ɵdid(1, 114688, null, 0, i1.PaymentStatusComponent, [i2.Router, i3.CacheService, i2.ActivatedRoute], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var PaymentStatusComponentNgFactory = i0.ɵccf("app-payment-status", i1.PaymentStatusComponent, View_PaymentStatusComponent_Host_0, {}, {}, []);
export { PaymentStatusComponentNgFactory as PaymentStatusComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/payments/payment-status.component.ngfactory.js.pre-build-optimizer.js